import { useParams } from 'react-router';
import { Token } from '../../model/Model';
import { useStyleStore } from '../../state/state';
import React, { useEffect, useMemo } from 'react';

export const SiteStyle = () => {
    const { token } = useParams<Token>();
    const { logo, style, linkColor, loaded, fetch } = useStyleStore();

    useEffect(() => {
        if (token && fetch && !loaded ) {
            fetch(token)
        }
    }, [fetch, token, loaded])

    const css = useMemo(() => {
        const cssSource = `
            .logo {
                content: url("${logo}");
                height: 80px;
                width: auto;
            }
            .btn-lg {
                border: 0;
            }
            .btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active {
               background-color: ${style};
            }
            .btn-primary.focus, .btn-primary:focus {
               background-color: ${style};
               border-color: ${style};
               box-shadow: 0 0 0 0;
            }
            .btn-primary:hover {
               background-color: ${style};
            }
            .btn-primary:disabled {
               background-color: ${style};
            }
            .btn-primary {
               background-color: ${style};
            }
            .btn-light {
                color: ${style};
            }
        `;
        if (linkColor) {
            return cssSource + `
            .declaration a {
                color: ${linkColor} !important;
            }
            `;
        }
        return cssSource;
    }, [style, logo, linkColor])


    return style ? (
        <style>{css}</style>
    ) : null;

}
